import { IRegionInterviewConfig, IStudentRow } from 'types';
import { IEventType } from '@/store/event_types/types';
import { getActiveRecordedInterviews } from '@/utilities/getActiveRecordedInterviews';
import { getActiveScheduledInterviews } from '@/utilities/getActiveScheduledInterviews';
import { ICancelInterviewModalV2Data } from '@/components/pages/modals/cancelInterviewV2';
import { IRequestInterviewModalV2Data } from '@/components/pages/modals/requestNewInterviewV2';
import { ActionSelection } from '../../../types';

export const handleScheduledInterviewsAction = async (
  action: ActionSelection,
  visibleStudents: IStudentRow[],
  selectedRows: string[],
  requestRecordedInterview: (uni: string, students: string[], regionInterviewConfig: IRegionInterviewConfig) => void,
  requestScheduledInterview: (uni: string, students: string[], eventType: IEventType) => void,
  cancelScheduledInterview: (
    uni: string,
    studentNo: string,
    intakeId: string,
    offerId: string,
    eventTypeId: string,
    eventKey: string,
    eventCancelUrl?: string,
  ) => void,
  cancelRecordedInterview: (
    uni: string,
    studentNo: string,
    intakeId: string,
    offerId: string,
    interviewHash: string,
  ) => void,
  cancelScheduledInterviewBulk: (uni: string, students: string[], eventType: IEventType) => void,
  cancelRecordedInterviewBulk: (uni: string, students: string[], regionInterviewConfig: IRegionInterviewConfig) => void,
  onShowRequestInterviewActionModal: (modalData: IRequestInterviewModalV2Data) => void,
  onShowCancelInterviewActionModal: (modalData: ICancelInterviewModalV2Data) => void,
) => {
  const studentKeys = visibleStudents?.filter(value => selectedRows.indexOf(value.p_key) > -1).map(s => s.p_key) ?? [];
  // TODO get a list of distinct values, return false if lenght !== 0
  const [uni] = studentKeys[0].split('#');

  const handleRequestInterviewAction = (eventType?: IEventType, regionInterviewConfig?: IRegionInterviewConfig) => {
    if (!studentKeys) {
      return false;
    }

    if (eventType) {
      return requestScheduledInterview(uni, studentKeys, eventType);
    }
    return requestRecordedInterview(uni, studentKeys, regionInterviewConfig as IRegionInterviewConfig);
  };

  const handleCancelInterviewBulkAction = (eventType?: IEventType, regionInterviewConfig?: IRegionInterviewConfig) => {
    if (eventType) {
      return cancelScheduledInterviewBulk(uni, studentKeys, eventType);
    } else if (regionInterviewConfig) {
      return cancelRecordedInterviewBulk(uni, studentKeys, regionInterviewConfig);
    }
  };

  const handleCancelInterviewAction = (data: {
    eventTypeId?: string;
    eventKey?: string;
    eventCancelUrl?: string;
    interviewHash?: string;
  }) => {
    const { eventTypeId, eventKey, eventCancelUrl, interviewHash } = data;

    const selectedStudent = visibleStudents.find(value => value.p_key === selectedRows[0]);
    if (!selectedStudent) {
      return false;
    }
    const [uni, studentNo, intakeId, offerId] = selectedStudent.p_key.split('#');

    if (eventKey && eventTypeId) {
      return cancelScheduledInterview(uni, studentNo, intakeId, offerId, eventTypeId, eventKey, eventCancelUrl);
    } else if (interviewHash) {
      return cancelRecordedInterview(uni, studentNo, intakeId, offerId, interviewHash);
    }
  };

  const getActiveInterviews = () => {
    const selectedStudentRows: IStudentRow[] = visibleStudents?.filter(value => selectedRows.indexOf(value.p_key) > -1);
    if (selectedStudentRows.length !== 1) {
      return [];
    }
    const activeCalendlyInterviews = getActiveScheduledInterviews(
      (selectedStudentRows[0] as any)?.calendlyInterviews ?? [],
    );
    const activeRecordedInterviews = getActiveRecordedInterviews(
      (selectedStudentRows[0] as any)?.recordedInterviews ?? [],
    );
    return [...activeCalendlyInterviews, ...activeRecordedInterviews];
  };

  const selectedStudentRows = visibleStudents?.filter(value => selectedRows.indexOf(value.p_key) > -1);
  const pathway = selectedStudentRows[0]?.pathway;
  if (action === ActionSelection.REQUEST_INTERVIEW) {
    onShowRequestInterviewActionModal({
      modalTitle: 'Invite to interview',
      confirmationButtonText: 'Send invitation',
      uni: uni ? uni : '',
      pathway: pathway ?? '',
      clickAction: (eventType?: IEventType, regionInterviewConfig?: IRegionInterviewConfig) =>
        handleRequestInterviewAction(eventType, regionInterviewConfig),
    });
  } else {
    const activeInterviews = getActiveInterviews();

    onShowCancelInterviewActionModal({
      modalTitle: 'Cancel interview',
      descriptionText: 'Choose interview to cancel',
      noticeText:
        'If you are cancelling an interview that is not yet booked, the event will be removed, otherwise you will see a followup dialog to Cancel Event.',
      confirmationButtonText: 'Request cancellation',
      cancelButtonText: 'Don’t cancel',
      assignedInterviews: activeInterviews ?? [],
      uni: uni ? uni : '',
      pathway: pathway ?? '',
      clickAction: ({ eventTypeId, eventKey, eventCancelUrl, interviewHash }) =>
        handleCancelInterviewAction({ eventTypeId, eventKey, eventCancelUrl, interviewHash }),
      clickBulkAction: (eventType?, regionInterviewConfig?) => {
        handleCancelInterviewBulkAction(eventType, regionInterviewConfig);
      },
    });
  }
};
